import React from 'react';

import HorizontalNav6 from '../components/horizontal-navs/HorizontalNav6';
import Testimonials4 from '../components/testimonials/Testimonials4';
import Footer2 from '../components/footers/Footer2';

export default function Testimonials() {
  return (
    <React.Fragment>
      <HorizontalNav6 content={null} />

      <Testimonials4 content={null} />

      <Footer2 content={null} />
    </React.Fragment>
  );
}

